import ListView, { ListViewItem } from '@ingka/list-view';
import { useNestedTranslation } from 'hooks/useNestedTranslation';
import type { Coworker } from 'types/coworker';
import CoworkerData from './CoworkerData';

const CoworkerFutureData = ({ futureData }: { futureData: Partial<Coworker> }) => {
    const t = useNestedTranslation('managecapacity.table');

    if (!futureData) {
        return null;
    }

    const { contractStartDate, contractEndDate } = futureData;

    return (
        <ListView id="coworker-future-details-content" data-testid="coworker-future-details-list-view">
            {contractStartDate != null && (
                <ListViewItem
                    data-testid="coworker-future-data-upcoming-changes"
                    inset
                    emphasised
                    title={`${t('upcoming_changes')} ${contractStartDate}`}
                    size="small"
                    showDivider
                />
            )}
            {contractStartDate != null && (
                <ListViewItem
                    data-testid="coworker-future-data-contract-period"
                    inset
                    emphasised
                    title={t('contractPeriod')}
                    description={`${contractStartDate} ${t('until')} ${contractEndDate ?? t('N/A')}`}
                    size="small"
                    showDivider
                />
            )}
            {Object.entries(futureData).map(([key, value]) => {
                if (key === 'contractStartDate' || key === 'contractEndDate' || value == null) {
                    return null;
                }

                return (
                    <ListViewItem
                        key={`coworker-future-${key}`}
                        data-testid={`coworker-future-data-${key}`}
                        inset
                        emphasised
                        title={t(key)}
                        description={<CoworkerData data={`${value}`} />}
                        size="small"
                        showDivider
                    />
                );
            })}
        </ListView>
    );
};

export default CoworkerFutureData;
